import styles from './banner.module.css';

function Banner({ imageSrc, title }) {
  return (
    <div className={styles.page_heading} >
      <img src={imageSrc} alt={title} />
      <h1>{title}</h1>
    </div>
  )
};

export default Banner;